import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'found';
import { Card, Grid, Segment } from 'semantic-ui-react';
import styles from '../../Event/Event.scss';

const TemplateGroup = ({ color, documentPath, documentType, templates }) => (
    templates.length > 0 &&
      <React.Fragment>
        <Grid.Row style={{ margin: '1em 0' }}>
          <Grid.Column>
            <h3>{documentType} Templates</h3>
          </Grid.Column>
        </Grid.Row>
        <Segment style={{ marginBottom: '2em' }}>
          <Grid.Row>
            <Grid.Column>
              <Card.Group itemsPerRow={4} doubling>
                {templates.map(template =>
                  <Link
                    to={`${documentPath}${template.node.id}/edit`}
                    Component={Card}
                    className={styles.workspaceCard}
                    color={color}
                    key={template.node.id}
                  >
                    <Card.Content>
                      <Card.Header>
                        {template.node.title}
                      </Card.Header>
                      <Card.Meta>{documentType}</Card.Meta>
                      <br />
                    </Card.Content>
                  </Link>
                )}
              </Card.Group>
            </Grid.Column>
          </Grid.Row>
        </Segment>
      </React.Fragment>
);

TemplateGroup.propTypes = {
  color: PropTypes.string.isRequired,
  documentPath: PropTypes.string.isRequired,
  documentType: PropTypes.string.isRequired,
  templates: PropTypes.array.isRequired
};

export default TemplateGroup;



// WEBPACK FOOTER //
// ./webpack/components/Document/Template/TemplateGroup.js